export default __webpack_public_path__ + "static/media/property-bg-image.252f48f8.svg";